export type ELegalRelationType = "Merchant" | "Partner" | "User"
export type ETermsProductType =
    | "WinBack"
    | "ReturnSell"
    | "PlusSell"
    | "AnywhereMobile"
    | "Acquiring"
    | "A2A"
    | "PSP"
    | "Klarna"
    | "Swish"
    | "ApplePay"
    | "Dankort"
    | "ViaBill"
    | "Anyday"
    | "Bancontact"
    | "Ideal"
    | "TermsTech"
    | "Forbrugsforeningen"
    | "Vipps"
    | "MobilePayOnline"
    | "Resurs"
    | "Dashboard"
    | "Tryg"
    | "SDK"
    | "Sandbox"
export type ETermsProvider = "Clearhaus" | "Digiteal"
export type ETermsCategory = "GeneralTerms" | "PrivacyPolicy" | "Agreement"

export const allTermsTypes = [
    "TermsMerchant",
    "TermsUser",
    "TermsPartner",
    "MerchantPartnerAgreement",
    "PrivacyPolicyShared",
    "TermsReturnSell",
    "TermsPlusSell",
    "TermsWinBack",
    "TermsAnywhereMobile",
    "DataProcessingAgreement",
    "TermsAcquiringClearhaus",
    "TermsPayFaqDigiteal",
    "TermsA2a",
    "TermsPSP",
    "TermsKlarna",
    "TermsSwish",
    "TermsApplePay",
    "TermsDankort",
    "TermsViaBill",
    "TermsAnyday",
    "TermsBancontact",
    "TermsIdeal",
    "TermsTermsTech",
    "TermsForbrugsforeningen",
    "TermsVippsPsp",
    "TermsVippsEpayment",
    "TermsMobilePayOnline",
    "TermsResurs",
    "TermsExternalAnalytics",
    "TermsTrygUser",
    "TermsEcomSDK",
    "TermsSandbox",
] as const
export type ETermsType = (typeof allTermsTypes)[number]
